import { ModalGlass } from "../../components/modal";

export default function SustainablePage() {
  return (
    <div
      className="h-full w-full pt-28"
      style={{
        backgroundImage:
          "url(https://static.igem.wiki/teams/4260/wiki/imagen/social-impact/social-impact-fon.png)",
        minHeight: "100vh",
        width: "100vw",
      }}
    >
      <div className=" m-8" style={{ style: "float" }}>
        <h1 className="text-7xl text-center text-white">
          SUSTAINABLE DEVELOPMENT IMPACT
        </h1>
        <div className="flex pt-12">
          <img
            className="m-left flex-1"
            src="https://static.igem.wiki/teams/4260/wiki/social-impact-venn-800.png"
            alt="Social Impact Venn diagram"
            style={{ width: 500, minWidth: 500, maxWidth: 500 }}
          />
          <div className="flex-1 p-4 text-white">
            <h2
              className="cano text-7xl text-center text-white"
              style={{ color: "white", display: "flex", fontSize: "30px" }}
            >
              INTRODUCTION
            </h2>

            <p
              className="p-justify"
              style={{ color: "white", display: "flex", fontSize: "16px" }}
            >
              When it comes down to making an impact on the world’s most urgent
              matters through science, it goes without saying that both taking
              into account and coming up with sustainable ways of tackling the
              biggest challenges, SDGs could not be left behind at all. SDGs,
              better known as the Sustainable Development Goals, are 17 urgent
              calls for action by all countries - developed and developing - in
              a global partnership. They recognize that ending poverty and other
              deprivations must go hand-in-hand with strategies that improve
              health and education, reduce inequality, and spur economic growth
              – all while tackling climate change and working to preserve our
              oceans and forests [1].
            </p>
            <p className="p" style={{ fontSize: "16px" }}>
              Presently, science has been working quite closely in alliance with
              the SDGs since we live in a fast-growing world that constantly
              requires brand-new updates, improvements, and initiatives that can
              change the course of humanity forestalling an apocalyptic ending
              to the world as we know it.
            </p>

            <p className="p" style={{ fontSize: "16px" }}>
              The UN and its science advisers — on
              the SDGs especially — need to work at speed and involve
              under-represented communities, all of which will require extra
              resources, including more people and more funding. Without this,
              it’s not realistic to expect them to work differently. But
              business as usual is not an option. Continued research will be
              needed to support action to end the current crisis and get onto a
              pathway to greater well-being and, eventually, prosperity and
              environmental sustainability [2].Through actions that have an impact on working at the legislative
              level, building a climate change action plan in place for the
              short-term, since Mexico is in 49th place in the Global
              Sustainability Index [3].
            </p>
            <h3
              className="cano text-7xl pt-8"
              style={{ color: "white", display: "flex", fontSize: "25px" }}
            >
              SDGs Target
            </h3>
            <p
              className="p-justify"
              style={{ color: "white", display: "flex", fontSize: "16px" }}
            >
              With our project we aim to target 4 of the 17 Sustainable
              Development Goals of the United Nations, all the objectives are
              pretended to be done by 2030.
            </p>

          </div>
        </div>
        <h2
          className="cano text-7xl text-white pt-17"
          style={{ color: "white", display: "flex", fontSize: "30px", marginTop:"20px"}}
        ><center>CLICK for more inormation</center>
        </h2>

        <img
          className="m-auto"
          src="https://static.igem.wiki/teams/4260/wiki/imagen/laboratory/fotos-parts/sustainable/ods-sustainable-acomodo.png"
          alt="ODS"
          style={{ width: 1300, minWidth: 1300, maxWidth: 1300 }}
          useMap="#ods_map"
        />

        <map name="ods_map">
          <area
            target=""
            alt="3GOOD-HEALTH"
            title="3GOOD-HEALTH"
            onClick={() => {
              document.getElementById("ods3_modal").click();
            }}
            coords="3,17,288,304"
            shape="rect"
          />
          <area
            target=""
            alt="6CLEAN-WATER"
            title="6CLEAN-WATER"
            onClick={() => {
              document.getElementById("ods6_modal").click();
            }}
            coords="339,15,625,304"
            shape="rect"
          />
          <area
            target=""
            alt="14LIFE-BELOW"
            title="14LIFE-BELOW"
            onClick={() => {
              document.getElementById("ods14_modal").click();
            }}
            coords="676,17,963,304"
            shape="rect"
          />
          <area
            target=""
            alt="15LIFE-ON"
            title="15LIFE-ON"
            onClick={() => {
              document.getElementById("ods15_modal").click();
            }}
            coords="1010,15,1299,304"
            shape="rect"
          />
          <area
            target=""
            alt="4QUALITY"
            title="4QUALITY"
            onClick={() => {
              document.getElementById("ods4_modal").click();
            }}
            coords="189,415,436,666"
            shape="rect"
          />
          <area
            target=""
            alt="12RESPONSIBLE"
            title="12RESPONSIBLE"
            onClick={() => {
              document.getElementById("ods12_modal").click();
            }}
            coords="527,419,773,666"
            shape="rect"
          />
          <area
            target=""
            alt="17PARTNERSHIPS"
            title="17PARTNERSHIPS"
            onClick={() => {
              document.getElementById("ods17_modal").click();
            }}
            coords="864,418,1110,664"
            shape="rect"
          />
        </map>
      </div>

      {/* Template de modal, copiar todo el modal glass, cambiar el modalId y la info de adentro*/}
      <ModalGlass modalId="ods3_modal">
        <div className="text-white">
          <h3 className="h3">SUSTAINABLE DEVELOPMENT GOAL 3 (Good health and well-being)</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/ingles/sdg3.png"
            alt="ODS3"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="p">It is undeniable that microplastics have been found in the human bodys, the pathways of exposure include ingestion, inhalation and dermal contact. This can impact human health, with the help of the United Nations, the SDG 3 ensures healthy lives and promotes well-being for all at all ages [4].</p>
          <p className="p">Through the design of our biosensor as a tool for quantifying EDCs and degradation of microplastics, health risks caused by the accumulation of endocrine disruptors. Such as blood alterations, genotoxicity, lung diseases, among others, are considered as a crucial factor for our project, providing good quality food and water to everyone (which in turn corresponds to one of the main SDGs). These health alterations could be reduced by detecting and degrading the endocrine disruptors, increasing the quality of life for everyone.
          </p>
          <p className="p"><strong>3.9</strong> “Substantially reduce the number of deaths and illnesses caused by hazardous chemicals and air, water, and soil pollution and contamination.”
          </p>
          <p className="p">The focus is towards the water and will take the impact to the ground
            for cultivation. Contamination caused by endocrine disruptors in irrigation water and harvest soil will be reduced.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="ods6_modal">
        <div className="text-white">
          <h3 className="h3">SUSTAINABLE DEVELOPMENT GOAL 6 (Water and sanitation)
          </h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/ingles/sdg6.png"
            alt="ODS6"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="p">The presence of microplastics in drinking water and treated wastewater effluent  has been a problem that has grown recently. The World Health Organization has recognized the presence of these chemicals in municipal and bottled drinking water, and are released directly in aquatic ecosystems and indirectly to agricultural soils. The SDG 6 ensures water and sanitation for all. </p>
          <p className="p">For humans it is crucial to have access to clean water, whether it is for agricultural, industrial or alimentary matters, nevertheless, the presence of microplastics could affect humans health and an accumulation in plants that affects their development, due to being considered endocrine disruptors [5]. That is why in our project we intend to capture and degrade microplastics contained in the water that is commonly used to provide sanitation and clean water especially in the agricultural sector.
          </p>
          <p className="p">
            <strong>6.3</strong> “Improve water quality by reducing pollution, eliminating dumping and minimizing the emission of chemicals and hazardous materials.”
          </p>
          <p className="p">Endocrine disruptors are emitted from waste and chemicals such as pharmaceuticals, the ocean, drinking water, and rainwater; With our biosensor, they will be reduced through the degradation of these and improve the quality of irrigation water.
          </p>
          <p className="p"> <strong>6.a</strong> “Expand international cooperation and support provided to developing countries for capacity building in activities and programs related to water and sanitation, such as water harvesting, desalination, efficient use of water resources, wastewater treatment, recycling and reuse technologies.”
          </p>
          <p className="p">Creation of a sanitation and wastewater treatment program with our product capable of degrading and quantifying endocrine disruptors through Human practices to seek international cooperation.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="ods12_modal">
        <div className="text-white">
          <h3 className="h3">SUSTAINABLE DEVELOPMENT GOAL 12 (Responsible consumption and production)</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/ingles/sdg12.png"
            alt="ODS12"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="p">The unsustainable global plastic production, plastic consumption, and plastic waste mismanagement has led to the situation we are facing today against microplastics [6]. The SDG 12 ensures sustainable consumption and production patterns.
          </p>
          <p className="p"> <strong>12.4</strong> “By 2020, achieve the ecological and rational management of chemical products and of all the waste throughout their lifetime according to the international forms and reduce their atmospheric, water and ground liberation, in order to minimize their negative impact in human health and in the environment.”
          </p>
          <p className="p">Taking into account that much of  the residual water used in agricultural crops contains microplastics, the development and implementation of our biosensor would prevent them from being dispersed. In this way an improvement in the management of the final deposition of the food products would be achieved, preventing them from damaging the environment.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="ods14_modal">
        <div className="text-white">
          <h3 className="h3">SUSTAINABLE DEVELOPMENT GOAL 14 (Life below water)
          </h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/ingles/sdg14.png"
            alt="ODS14"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="p">Marine pollution by plastics has been a major global environmental issue in recent decades, due to the problems of end-of-life plastic, with the presence of microplastic in the oceans, this affects the wildlife and ecosystems, because the particle size is more bioavailable (or injectable). The SDG 14 aims to conserve and sustainably use the oceans, seas and marine resources.
          </p>
          <p className="p">We consider that this project also involves submarine life by setting the goal of dissolving the endocrine disruptors, since the microplastics could endanger their health and even their lives.
          </p>
          <p className="p"><strong>14.1</strong> “By 2025, prevent and significantly reduce marine pollution of all kinds, in particular from land-based activities, including marine debris and nutrient pollution.”
          </p>
          <p className="p">Marine pollution by plastics has been a major global environmental issue in recent decades, due to the problems of end-of-life plastic, with the presence of microplastic in the oceans, this affects the wildlife and ecosystems, because the particle size is more bioavailable (or injectable). The SDG 14 aims to conserve and sustainably use the oceans, seas and marine resources.
          </p>
          <p className="p">Contamination by endocrine disruptors occurs in all areas, but agricultural activities distribute them in foods such as lettuce; by removing them from the water, one of the ways of distribution to other parts is eliminated.
          </p>
          <p className="p"><strong>14.a</strong> “Increase scientific knowledge, develop research capacity and transfer marine technology, taking into account the Criteria and Guidelines for the Transfer of Marine Technology of the Intergovernmental Oceanographic Commission, in order to improve the health of the oceans and enhance the contribution of marine biodiversity to the development of developing countries, in particular small island developing States and least developed countries.”
          </p>
          <p className="p">Bring knowledge of endocrine disruptors to the community in general through surveys and conferences; showing the purpose of reducing the amount of endocrine disruptors in oceanic water through their degradation.
          </p>
          <p className="p"><strong>14.c</strong> “Improve the conservation and sustainable use of the oceans and their resources by applying international law reflected in the United Nations Convention on the Law of the Sea, which constitutes the legal framework for the conservation and sustainable use of oceans. oceans and their resources.”
          </p>
          <p className="p">The oceans deteriorate and become polluted by receiving endocrine disruptors from the irrigation water that flows into them; Through the degradation of this, the endocrine disruptors perceived by this part will be practically null and a better conservation of it will be achieved. This will be reached through preventive actions to avoid contamination of irrigation water before it reaches the oceans.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="ods15_modal">
        <div className="text-white">
          <h3 className="h3">SUSTAINABLE DEVELOPMENT GOAL 15 (Life on land)</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/ingles/sd15.png"
            alt="ODS15"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="p">It is vitally important that science takes into account the quality of the environment and ensures the health of terrestrial life, so our project aims to ensure the good quality of life on earth.
          </p>
          <p className="p">Several activities were carried out in order to protect the life of terrestrial ecosystems, among them we focused mainly on the reforestation of the Bosque de los Remedios forest, which was in danger of extinction despite being considered one of the last lungs of the municipality. This was done in collaboration with the Nacel Arcoiris association and 550 trees were planted in the area. During the activity we found large amounts of garbage (unicel, clothes, plastic containers, among others) which our team cleaned up and then planted 4 species of trees endemic to the area (Figure 1). We also organized a reforestation of a green space on our campus, where we had the presence of students and were able to plant about 200 trees (Figure 2).
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/figura1-1.jpeg"
            alt="reforestación"
            className="figure"
            style={{ width: 300 }}
          />
          <p className="figure_desc"> Fig. 1 <i> iGEM Tec-Cem team in the reforestation of Bosque de los Remedios.</i></p>
          <p className="p">Taking into account that much of  the residual water used in agricultural crops contains microplastics, the development and implementation of our biosensor would prevent them from being dispersed. In this way an improvement in the management of the final deposition of the food products would be achieved, preventing them from damaging the environment.
          </p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/figura2.jpeg"
            alt="reforestación2"
            className="figure"
            style={{ width: 300 }}
          />
          <p className="figure_desc"> Fig. 2 <i> Members of the campus reforestation group.</i></p>
          <h4 className="h3">Our work against SDGs
          </h4>
          <p className="p">For the iGEM TEC-CEM Team has been important to integrate not only the SDGs that target the project, but also contribute with affairs like education, climate change, and other goals, by involving diverse collaborations and activities to implement sustainable strategies, in order to create awareness in the iGEM community of the importance of implementing sustainable work with science. Visit the Human Practices tab to learn more about the team's activities to combat the SDGs.
          </p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="ods4_modal">
        <div className="text-white">
          <h3 className="h3">SUSTAINABLE DEVELOPMENT GOAL 4  (Quality Education)</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/ingles/sdg4.png"
            alt="ODS4"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="p">In addition to the direct benefits that our proposal could show, the team's intention was also to provide as many people as possible with information and interactive education about our project. Some of the actions that were carried out were: the creation of a coloring book for children whose theme focused on synthetic biology (laboratory materials, parts of a cell, among others), conferences about the substitution of traditional antibiotics and scientific dissemination regarding microplastics,talk about the SDGs to a low-income school, interactive activities and laboratory practices in which any public could participate, allowing them to get into different areas of biotechnology, as well as meeting with Rosa Wolpert, National Education Officer at UNESCO, about how to motivate study in the sciences, we contributed in gathering useful information for research on specific topics and surveys around our project.</p>
        </div>
      </ModalGlass>
      <ModalGlass modalId="ods17_modal">
        <div className="text-white">
          <h3 className="h3">SUSTAINABLE DEVELOPMENT GOAL 17  (Partnerships to achieve the Goal)</h3>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/ingles/sdg17.png"
            alt="ODS17"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="p">In order to achieve our project’s goals, to get feedback and support from other people involved in the science field and in the iGEM competition, we partnered with other iGEM teams nationally and internationally. We also contributed with professionals and  experts especially involved in the topic of endocrine disruptors. We also collaborated and got patronized by companies and institutions, like Thermofisher, Benchling, among others, in order to achieve the goals of our project.</p>
          <h4 className="h3">Stakeholders
          </h4>
          <p className="p">Some of the experts who accompanied us in advising the project regarding the selection and work on the SDGs presented, was the ODS Itinerant Museum association, dedicated to promoting awareness of environmental and social impacts. Thanks to their feedback we had an analysis of the positive and negative impact of the project, thus evaluating the areas of opportunity of the biosensor and degradation, the same association offered to give part of the staff of our team a training course on SDGs (Figure 3).</p>
          <img
            src="https://static.igem.wiki/teams/4260/wiki/sustainable/figura-3.png"
            alt="ODSmuseum"
            className="figure"
            style={{ width: 200 }}
          />
          <p className="figure_desc"> Fig. 3 <i>  iGEM Tec-CEM team at the Itinerant Museum of Sustainable Development Goals. </i></p>
        </div>
      </ModalGlass>
      <div className="p-4"><h3 className="h3 Cano text-white">References</h3>
        <p className="reference Cano text-white">
          [1] United Nations Department of Economic and Social Affairs. (2022). “Sustainable Development Goals”. The 2030 Agenda for Sustainable Development. Retrieved from: https://sdgs.un.org/goals
        </p>
        <p className="reference Cano text-white">
          [2]Nature. (2021). “How science can put the Sustainable Development Goals back on track”. Nature 589, 329-330 (2021). Retrieved from: https://doi.org/10.1038/d41586-021-00104-0
        </p>
        <p className="reference Cano text-white">
          [3]Mulhern, O. (2020, 8 julio). Mexico – Ranked 49th in the Global Sustainability Index. Earth.Org. Retrieved the 5 of october of 2022, from https://earth.org/global_sustain/mexico-ranked-49th-in-the-global-sustainability-index/

        </p>
        <p className="reference Cano text-white">
          [4]Yuan, Z., Nag, R., & Cummins, E. (2022). Human health concerns regarding microplastics in the aquatic environment - From marine to food systems. In Science of The Total Environment (Vol. 823, p. 153730). Elsevier BV. https://doi.org/10.1016/j.scitotenv.2022.153730

        </p>
        <p className="reference Cano text-white">
          [5]Azeem, I., Adeel, M., Ahmad, M. A., Shakoor, N., Jiangcuo, G. D., Azeem, K., Ishfaq, M., Shakoor, A., Ayaz, M., Xu, M., & Rui, Y. (2021). Uptake and Accumulation of Nano/Microplastics in Plants: A Critical Review. In Nanomaterials (Vol. 11, Issue 11, p. 2935). MDPI AG. https://doi.org/10.3390/nano11112935

        </p>
        <p className="reference Cano text-white">
          [6]de Sousa, F. D. B. (2021). The role of plastic concerning the sustainable development goals: The literature point of view. In Cleaner and Responsible Consumption (Vol. 3, p. 100020). Elsevier BV. https://doi.org/10.1016/j.clrc.2021.100020

        </p></div>
    </div>
  );
}
